import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setChartPopUp } from 'stores/sensor/sensorStore';
import { brandColors } from 'types/colors';

import FormattedChart from './components/FormattedChart';

const sensorChartLabels = {
  clean_air_level_min: 'Clean Air Level',
  comfort_level_avg: 'Comfort Level',
  mass_pm_2_5_max: 'PM 2.5',
  mass_pm_10: 'PM 10',
  mass_pm_10_max: 'PM 10',
  rh_avg: 'RH',
  dp_mean: 'Differential Pressure',
  assigned_hvac_equipment_state: 'HVAC Power',
};

function cleanAndCapitalize(input) {
  if (input === 'co2_ratio_min') {
    return 'Ventilation';
  }
  if (input === 'motion_counter') {
    return 'Motion';
  }
  const substringsToRemove = ['mass', 'min', 'max'];

  let cleanedString = input;

  cleanedString = cleanedString.replace(/_/g, ' ');

  substringsToRemove.forEach(substring => {
    const regex = new RegExp(substring, 'gi'); // Case-insensitive match
    cleanedString = cleanedString.replace(regex, '');
  });

  cleanedString = cleanedString.trim();
  return cleanedString.charAt(0).toUpperCase() + cleanedString.slice(1);
}

export const getSensorChartDataset = (measurements, measurmentName) => {
  if (measurmentName === 'tvoc_max') {
    return {
      // tvoc_max is already converted to TVOC mass before it is saved.
      data: measurements,
      label: 'TVOC',
    };
  }

  return {
    data: measurements,
    // label: MeasurmentDisplayString[measurmentName],
    label: sensorChartLabels[measurmentName] ?? cleanAndCapitalize(measurmentName),
  };
};

const Charts = ({
  onChartRangeSelect,
  chartRangeButtons,
  compact = false,
  datasetColors,
  formatTooltipValue,
  measurementsData: measurementsDataProp,
}) => {
  const measurementsDataFromStore = useSelector(state => state.sensors.data.minMaxRangeMeasurements);
  const measurementsData = measurementsDataProp ?? measurementsDataFromStore;
  // const selectedGraphs = useSelector(state => state.sensors.selectedGraphs);
  // console.log('selectedGraphs:', selectedGraphs);
  // const rangeObj = useSelector(state => state.sensors.timeRange);

  // const { auth } = useAuth();

  const sensorId = useParams().id;
  // console.log("Charts sensorId:",sensorId);
  // const [chartPopUp, setChartPopUp] = useState();
  // const selectedGraphs = useSelector(state => state.sensors.selectedGraphs);
  return (
    <>
      {/* prettier-ignore */}
      <FormattedChart
          title={sensorId}
          datasets={Object.keys(measurementsData).map(name => 
            {
              const dataset = getSensorChartDataset(measurementsData[name], name);
              const color = name.endsWith('_requested')
                ? brandColors.RED
                : name.endsWith('_justified')
                  ? brandColors.BLUE
                  : name.endsWith('_saveable')
                    ? brandColors.GREEN
                    : datasetColors?.[name];
              return { ...dataset, measurementName: name, color };
            }
          )}
          isRange={false}
          setChartPopUp={setChartPopUp}
          sensorId={sensorId}
          onChartRangeSelect={onChartRangeSelect}
          chartRangeButtons={chartRangeButtons}
          compact={compact}
          formatTooltipValue={formatTooltipValue}
          preventAllSeriesHidden
        />
    </>
  );
};

Charts.propTypes = {
  onChartRangeSelect: PropTypes.func,
  chartRangeButtons: PropTypes.array,
  compact: PropTypes.bool,
  datasetColors: PropTypes.object,
  formatTooltipValue: PropTypes.func,
  measurementsData: PropTypes.object,
};

export default Charts;
